import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'block-container',
  props: {
    // 布局类型
    type: {
        type: String as PropType<'row' | 'column'>,
        default: '',
    },
    className: {
        type: String,
        default: '',
    },
    align: {
        type: String as PropType<'start' | 'center' | 'end'>,
        default: 'start',
    },
    justify: {
        type: String as PropType<'start' | 'center' | 'end'>,
        default: 'start',
    },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _mergeProps({
    class: [
            'block-container',
            {
                vertical: __props.type === 'column',
                'align-start': __props.align === 'start',
                'align-center': __props.align === 'center',
                'align-end': __props.align === 'end',
                'justify-start': __props.justify === 'start',
                'justify-center': __props.justify === 'center',
                'justify-end': __props.justify === 'end',
            },
            __props.className,
        ]
  }, _ctx.$attrs), [
    _renderSlot(_ctx.$slots, "default")
  ], 16))
}
}

})